export class CustomEvent
{
    public target: any = null as any;
    private defaultPrevented: boolean = false;

    constructor(private _type: string)
    {
    }

    public preventDefault(): void
    {
        this.defaultPrevented = true;
    }

    public isDefaultPrevented(): boolean { return this.defaultPrevented; }
    public get type(): string { return this._type; }
}